import { Pipe, PipeTransform } from '@angular/core';
import { AfasFunction } from '../classes/afas-function.class';
import { Role } from '../classes/auth/role.class';

@Pipe({
    name: 'functionHasRole',
    standalone: false,
})
export class FunctionHasRolePipe implements PipeTransform {
    transform(func: AfasFunction, role: Role): boolean {
        return !!func.roles?.find(r => r.key === role.key);
    }
}
